export const getMobileOperatingSystem = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  const userAgent = navigator && (navigator.userAgent || navigator.vendor || window.opera);

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'windows';
  }

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  return null;
};



// WEBPACK FOOTER //
// ./helpers/mobile.helper.js